import { refetchTopicAndQuestionDetails } from "@/lib/quizzes";
import { apiErrorToToast } from "@/lib/utils";
import {
  updateQuizAnswerInBatch,
  UpdateQuizAnswerInBatchRequestParams,
} from "@/requests/questionnaries/update-quiz-answer-in-batch.request";
import { ApiErrorResponse } from "@/types/apis";
import { DimensionId } from "@/types/questionnaries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { buildAnswerByResponseIdQueryKey } from "./answer-by-response-id.hook";

export type UpdateQuizAnswerInBatchMutationParams =
  UpdateQuizAnswerInBatchRequestParams & {
    dimension: string;
    topic: string;
    invalidateQuestionResponses: boolean;
  };

export const useUpdateQuizAnswerInBatchMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: UpdateQuizAnswerInBatchMutationParams) =>
      updateQuizAnswerInBatch(variables),

    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },

    // Update the topic and the dimension when the answer is saved successfully
    onSuccess: (_, variables) => {
      refetchTopicAndQuestionDetails({
        queryClient,
        companyId: variables.companyId,
        quizId: variables.quizId,
        responseId: variables.responseId,
        dimension: variables.dimension as DimensionId,
        topic: variables.topic,
      });
    },

    // If needed, invalidate the question answers/choices
    onSettled: (_, __, variables) => {
      if (variables.invalidateQuestionResponses) {
        const answerQueryKey = buildAnswerByResponseIdQueryKey({
          companyId: variables.companyId,
          quizId: variables.quizId,
          responseId: variables.responseId,
        });

        queryClient.refetchQueries({
          queryKey: answerQueryKey,
        });
      }
    },
  });
};
